module.exports = __webpack_public_path__ + "img/Logo-21.5ef48dea.svg";